import { useState, useCallback, useEffect } from 'react';
import type { ViewMode } from '../components/ui/ViewToggle';

const STORAGE_KEY_PREFIX = 'innovate-view-mode-';

export function useViewMode(entityType: string, defaultMode: ViewMode = 'grid') {
  const storageKey = `${STORAGE_KEY_PREFIX}${entityType}`;

  const [viewMode, setViewMode] = useState<ViewMode>(() => {
    if (typeof window === 'undefined') return defaultMode;
    const stored = localStorage.getItem(storageKey);
    return (stored as ViewMode) || defaultMode;
  });

  const updateViewMode = useCallback(
    (mode: ViewMode) => {
      setViewMode(mode);
      localStorage.setItem(storageKey, mode);
    },
    [storageKey]
  );

  // Sync with localStorage on mount
  useEffect(() => {
    const stored = localStorage.getItem(storageKey);
    if (stored && (stored === 'grid' || stored === 'list')) {
      setViewMode(stored);
    }
  }, [storageKey]);

  return [viewMode, updateViewMode] as const;
}
